import { render, staticRenderFns } from "./CardCaptureNew.vue?vue&type=template&id=6bd1787c&scoped=true&"
import script from "./CardCaptureNew.vue?vue&type=script&lang=js&"
export * from "./CardCaptureNew.vue?vue&type=script&lang=js&"
import style0 from "./CardCaptureNew.vue?vue&type=style&index=0&id=6bd1787c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd1787c",
  null
  
)

export default component.exports